import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { QPointIconModule } from '@qpoint/icons';
import { QPointContentContainerComponent, QPointToolbarButtonComponent, QPointToolbarComponent } from '@qpoint/layout';

import {
  QPointTabNavDetailTemplateDirective,
} from '../../../../projects/qpoint-layout/src/lib/components/tab-nav/tab-nav-detail-template.directive';
import { QPointTabNavItemComponent, } from '../../../../projects/qpoint-layout/src/lib/components/tab-nav/tab-nav-item.component';
import { QPointTabNavComponent } from '../../../../projects/qpoint-layout/src/lib/components/tab-nav/tab-nav.component';
import { guid } from '@progress/kendo-angular-common';
import { QPointTabNavMenuItemDirective } from '../../../../projects/qpoint-layout/src/lib/components';

@Component({
    selector: 'app-control-gallery-tabnavigation',
    templateUrl: './tabnavigation.component.html',
    styleUrls: ['./tabnavigation.component.scss'],
    imports: [
        QPointToolbarComponent, QPointContentContainerComponent, TabStripModule,
        NgbNavModule, QPointToolbarButtonComponent, QPointIconModule, QPointTabNavComponent,
        QPointTabNavItemComponent, QPointTabNavDetailTemplateDirective, CommonModule, QPointTabNavMenuItemDirective
    ]
})
export class ControlGalleryTabnavigationComponent {
  dynamicTabs = signal<{ title: string, content: string, id: string }[]>([]);
  activeId = signal<string>(undefined);
  tab3Name = signal('Tab 3');

  validatorFn = (name: string) => {
    if (name === 'Tab 1') {
      return ['Tab 1 already exists'];
    }
    return null;
  }

  addNewDynamicTab() {
    const id = guid();
    this.dynamicTabs.set([...this.dynamicTabs(), { title: 'New Tab ' + (this.dynamicTabs().length + 1), content: 'New Tab Content', id }])
    this.activeId.set(id);
  }

  clickTest() {
    console.log("CLICK TEST!")
  }
}
